import {kSystemIcons} from "../../../constants/icons";

export default function AboutMethodLevelComplexityImage() {
    // Used in AboutMethodSection to display explanation
    // about growing complexity in required skills

    // BUILD
    return (
        <div className={"mt-[24px] w-full flex justify-between items-center"}>
            <div className={"bg-knowledgeColor rounded-[8px] flex justify-center items-center w-[156px] min-w-[156px] h-[100px] min-h-[100px] text-[16px] text-whiteDark8 text-center px-[2px]"}>
                    <span className={"font-normal"}>
                        {"Définition de deux droites perpendiculaires"}
                    </span>
            </div>
            <div className={"grow flex justify-center items-center ml-[14px] mr-[2px]"}>
                <div className={"w-full h-[2px] min-h-[2px] bg-greyLight5"}>
                </div>
                <i className={`material-icons text-[24px] -ml-[14px] text-greyLight5`}>
                    {kSystemIcons.chevronRight}
                </i>
            </div>
            <div className={"bg-levelAColor rounded-[8px] flex justify-center items-center w-[156px] min-w-[156px] h-[100px] min-h-[100px] text-[16px] text-whiteDark8 font-medium text-center px-[4px]"}>
                    <span className={"font-medium"}>
                        {"Tracer une droite perpendiculaire à une autre"}
                    </span>
            </div>
            <div className={"grow flex justify-center items-center ml-[14px] mr-[2px]"}>
                <div className={"w-full h-[2px] min-h-[2px] bg-greyLight5"}>
                </div>
                <i className={`material-icons text-[24px] -ml-[14px] text-greyLight5`}>
                    {kSystemIcons.chevronRight}
                </i>
            </div>
            <div className={"bg-levelBColor rounded-[8px] flex justify-center items-center w-[156px] min-w-[156px] h-[100px] min-h-[100px] text-[16px] text-whiteDark8 font-medium text-center px-[4px]"}>
                    <span className={"font-semibold"}>
                        {"Tracer un carré"}
                    </span>
            </div>
        </div>
    );
}